import { useEffect, useState } from 'react';
import { postRequest } from '../interceptor/interceptor';
import moment from 'moment';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { GET_AUDIT_HISTORY } from '../../apiConst';
import { FaStar } from 'react-icons/fa';
import { FaCalendarDays, FaRegStar } from 'react-icons/fa6';

const Logs = ({ ticketNo }) => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = () => {
    let payload = {
      filter: { ticketNo: ticketNo },
    };

    postRequest(GET_AUDIT_HISTORY, payload)
      .then((res) => {
        setLogs(res?.data?.data?.result);
      })
      .catch((error) => {
        setLogs([]);
        console.log('🚀 ~ file: Logs.jsx:17 ~ fetcLogs ~ error:', error);
      });
  };

  return (
    <div>
      <VerticalTimeline lineColor={'#003f5c'}>
        {logs.length > 0 &&
          logs?.map((item) => {
            const { createdAt } = item;

            // Format the createdAt date for display
            const formattedDate =
              moment(createdAt).format('DD-MM-YYYY, h:mm a');

            return (
              <VerticalTimelineElement
                key={item._id}
                className="vertical-timeline-element--work"
                contentStyle={{
                  background: '#003f5c',
                  color: '#ffffff',
                }}
                contentArrowStyle={{
                  borderRight: '7px solid #003f5c',
                }}
                date={formattedDate}
                iconStyle={{ background: '#003f5c', color: '#fff' }}
                icon={<FaCalendarDays />}
              >
                {/* Dynamically render each key-value pair */}
                {Object.keys(item).map((key) => {
                  // Skip the 'createdAt', '_id', '__v', and 'ticketNo' fields
                  if (
                    key === 'createdAt' ||
                    key === '_id' ||
                    key === '__v' ||
                    key === 'ticketNo' ||
                    key === 'updatedAt' ||
                    key === 'isStepperForm' ||
                    key === 'ttdAvailableSlot'
                  ) {
                    return null;
                  }

                  const value = item[key];

                  // Handle nested objects (like 'ticketStatus', 'referralType', etc.)
                  if (typeof value === 'object' && value !== null) {
                    return (
                      <div key={key} className="mb-2">
                        <span className="text-white text-sm font-montsettat flex items-center gap-1">
                          <FaStar className="text-yellow-400 text-xs" />
                          {key.charAt(0).toUpperCase() + key.slice(1)} :
                        </span>
                        {Object.entries(value).map(
                          ([nestedKey, nestedValue]) => (
                            <div key={nestedKey} className="pl-4">
                              <span className="text-white/90 text-sm font-montsettat">
                                {nestedKey.charAt(0).toUpperCase() +
                                  nestedKey.slice(1)}{' '}
                                :
                              </span>{' '}
                              <span className="text-white/80 text-xs font-montsettat">
                                {nestedValue}
                              </span>
                            </div>
                          )
                        )}
                      </div>
                    );
                  }

                  // For regular key-value pairs
                  return (
                    <div key={key}>
                      {/* <span className="text-white/90 text-sm">
                      {key.charAt(0).toUpperCase() + key.slice(1)}:
                    </span>{" "} */}
                      <span className="text-white text-sm font-montsettat flex items-center gap-1">
                        <FaStar className="text-yellow-400 text-xs" />
                        {key.charAt(0).toUpperCase() + key.slice(1)} :
                        <span className="text-white/80 text-xs font-montsettat">
                          {value}
                        </span>
                      </span>
                    </div>
                  );
                })}
              </VerticalTimelineElement>
            );
          })}
        <VerticalTimelineElement
          iconStyle={{ background: 'red', color: '#fff' }}
          icon={<FaRegStar />}
        />
      </VerticalTimeline>
    </div>
  );
};
export default Logs;
